import { Component, OnDestroy, OnInit } from '@angular/core';

import { ListService } from '@fry/lib/list';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';
import { ActivatedRoute } from '@angular/router';
import { GeneralListResolved } from './general.list.interfaces';
import { ExportListService } from '@fry/components/common/list/list/export-list/export-list.service';


@Component({
    selector: 'eas-general-list',
    templateUrl: './general.list.component.html',
    providers: [
        ListService,
        ExportListService,
    ],
    standalone: false
})
export class GeneralListComponent implements OnInit, OnDestroy {

  public table = this.list.table;
  public actions: EASLinkAction[] = [];
  public title: string;
  public defaultColumns: string[];
  public storageKey: string;

  constructor(
    private list: ListService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(
      () => {
        const data: GeneralListResolved = this.route.snapshot.data.data;
        this.title = data.title;
        this.storageKey = data.type;
        this.defaultColumns = data.defaultColumns;
        this.list.reset();
        this.list.setupWith(data.store, data.search, undefined, data.defaults, data.type).subscribe();
        this.actions = data.actions ? data.actions : [];
      }
    );
  }

  ngOnDestroy() {
  }

}
